export default {
    jobApplyComplete: 'jobitem_apply_to_job_complete',
    jobDislikeComplete: 'jobitem_dislike_complete',
    view: 'jobitem_view',
    detailsView: 'jobitem_details_view',
    showPhoneClick: 'jobitem_show_phone_click',
    phoneClicked: 'jobitem_phone_click',
    jobsPurchased: 'jobs_purchased',
    jobsStartTransaction: 'jobs_start_transaction',
    cvUploadComplete: 'cv_upload_complete',
    employerRegistrationComplete: 'employer_registration_complete',
    candidateRegistrationComplete: 'candidate_registration_complete',
    smartAgentRegistrationComplete: 'smart_agent_registration_complete',
    contactUsComplete: 'contact_us_complete',
};
